import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 37,
  height: 32,
}

const Bed = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 37 32.067'
  >
    <g fill={color} transform='translate(0 -32)'>
      <path d='M36.383,50.5h-.617V48.65a3.083,3.083,0,0,0-1.85-2.822V36.317a.617.617,0,0,0-.37-.565,2.441,2.441,0,0,0,.37-1.285,2.467,2.467,0,1,0-4.933,0,2.442,2.442,0,0,0,.343,1.233H7.674a2.442,2.442,0,0,0,.343-1.233,2.467,2.467,0,1,0-4.933,0,2.441,2.441,0,0,0,.37,1.285.617.617,0,0,0-.37.565v9.511a3.083,3.083,0,0,0-1.85,2.822V50.5H.617A.617.617,0,0,0,0,51.117V59.75a.617.617,0,0,0,.617.617h.617V63.45a.617.617,0,0,0,.617.617H4.317a.617.617,0,0,0,.617-.617V60.367H32.067V63.45a.617.617,0,0,0,.617.617H35.15a.617.617,0,0,0,.617-.617V60.367h.617A.617.617,0,0,0,37,59.75V51.117A.617.617,0,0,0,36.383,50.5ZM31.45,33.233a1.233,1.233,0,1,1-1.233,1.233A1.233,1.233,0,0,1,31.45,33.233Zm-25.9,0a1.233,1.233,0,1,1-1.233,1.233A1.233,1.233,0,0,1,5.55,33.233Zm-1.233,3.7H32.683v8.633H30.2a3.051,3.051,0,0,0,.633-1.85V42.483A3.087,3.087,0,0,0,27.75,39.4H22.817a3.087,3.087,0,0,0-3.083,3.083v1.233a3.051,3.051,0,0,0,.633,1.85H16.634a3.051,3.051,0,0,0,.633-1.85V42.483A3.087,3.087,0,0,0,14.183,39.4H9.25a3.087,3.087,0,0,0-3.083,3.083v1.233a3.051,3.051,0,0,0,.633,1.85H4.317ZM29.6,42.483v1.233a1.85,1.85,0,0,1-1.85,1.85H22.817a1.85,1.85,0,0,1-1.85-1.85V42.483a1.85,1.85,0,0,1,1.85-1.85H27.75A1.85,1.85,0,0,1,29.6,42.483Zm-13.567,0v1.233a1.85,1.85,0,0,1-1.85,1.85H9.25a1.85,1.85,0,0,1-1.85-1.85V42.483a1.85,1.85,0,0,1,1.85-1.85h4.933A1.85,1.85,0,0,1,16.033,42.483ZM2.467,48.65a1.85,1.85,0,0,1,1.85-1.85H32.683a1.85,1.85,0,0,1,1.85,1.85V50.5H2.467ZM3.7,62.833H2.467V60.367H3.7Zm30.833,0H33.3V60.367h1.233Zm1.233-3.7H1.233v-7.4H35.767Z' />
      <path
        transform='translate(-29.533 -296.667)'
        d='M35.083,352H32.617a.617.617,0,1,0,0,1.233h2.467a.617.617,0,0,0,0-1.233Z'
      />
      <path
        transform='translate(-88.6 -296.667)'
        d='M122.517,352h-25.9a.617.617,0,0,0,0,1.233h25.9a.617.617,0,1,0,0-1.233Z'
      />
    </g>
  </svg>
)

export default Bed
